import history from "../middlewares/history";
import C from "../constants";
import config from "../config/config";
import { useCallback, useEffect, useRef, useState } from "react";

export function clickToLinkHandler(path) {
  window.scrollTo(0, 0);
  history.push(path);
}

export function getUserName(person) {
  if (person && (person.first_name || person.last_name)) {
    let name = "";
    if (person.first_name) {
      name += person.first_name + " ";
    }
    if (person.last_name) {
      name += person.last_name;
    }
    return name;
  } else if (person && (person.firstName || person.lastName)) {
    let name = "";
    if (person.firstName) {
      name += person.firstName + " ";
    }
    if (person.lastName) {
      name += person.lastName;
    }
    return name;
  } else if (person && person.email) {
    return person.email;
  }
  return "";
}

export function getAbbreviation(person) {
  if (person && (person.first_name || person.last_name)) {
    let name = "";
    if (person.first_name) {
      name += person.first_name[0] + " ";
    }
    if (person.last_name) {
      name += person.last_name[0];
    }
    return name;
  } else if (person && (person.firstName || person.lastName)) {
    let name = "";
    if (person.firstName) {
      name += person.firstName[0] + " ";
    }
    if (person.lastName) {
      name += person.lastName[0];
    }
    return name;
  }
  return "";
}

export function toISOString(date) {
  // if (Date.prototype.toISOString) {
  //     return date.toISOString();
  // }

  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }

  return (
    date.getUTCFullYear() +
    "-" +
    pad(date.getUTCMonth() + 1) +
    "-" +
    pad(date.getUTCDate()) +
    "T" +
    pad(date.getUTCHours()) +
    ":" +
    pad(date.getUTCMinutes()) +
    ":" +
    pad(date.getUTCSeconds()) +
    "." +
    (date.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
    "Z"
  );
}

export function getActionName(actionType) {
  if (typeof actionType !== "string") {
    return null;
  }

  return actionType.split("_").slice(0, -1).join("_");
}

export const formatNumber = (x) => {
  let parts = x.toString().split(".");
  let result = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  if (parts[1]) {
    result += "." + parts[1];
  }
  return result;
};

export const currencyFormat = (x) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  });

  return formatter.format(x);
};

export const getBaseUrl = () => {
  if (config.useSiteUrl) {
    return (
      window.location.protocol +
      "//" +
      window.location.hostname +
      config.apiVersion
    );
  }
  return config.baseUrl;
};

export function getOS() {
  let name = "Unknown OS";

  if (navigator.userAgent.indexOf("Win") !== -1) {
    name = C.WINDOWS;
  }

  if (navigator.userAgent.indexOf("Mac") !== -1) {
    name = C.MAC;
  }

  return name;
}

export const simpleSort = (a, b) => {
  return a < b ? -1 : a > b ? 1 : 0;
};
export function useStateCallback(initialState) {
  const [state, setState] = useState(initialState);
  const cbRef = useRef(null);

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb;
    setState(state);
  }, []);

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null;
    }
  }, [state]);

  return [state, setStateCallback];
}

export const validateEmail = (email) => {
  // eslint-disable-next-line no-control-regex, no-useless-escape
  const regexOfEmail = new RegExp(
    // eslint-disable-next-line no-control-regex
    "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
  );
  return regexOfEmail.test(email);
};

export const validateName = (name) => {
  const regexOfEmail = new RegExp("^\\w+\\s(\\w+){1}$");
  return regexOfEmail.test(name);
};
export const getDifferenceBetweenTwoObjects = (a, b) =>
  Object.fromEntries(
    Object.entries(b).filter(([key, val]) => key in a && a[key] !== val)
  );

export const updateUsersInvestorsAfterRemoveMember = (
  dealIvestorMembers,
  removedMember
) => {
  return dealIvestorMembers.filter(
    (im) => im.id !== removedMember.dealInvestorMemberId
  );
};

export const getPersonRoleByOrganizationId = (
  organizationsPersons,
  organizationId
) => {
  let roleId = 0;

  if (
    Object.prototype.toString.call(organizationsPersons) !== "[object Array]"
  ) {
    return roleId;
  }

  if (!organizationsPersons || !organizationsPersons.length) {
    return roleId;
  }
  const organizationPerson = organizationsPersons.find(
    (op) => (op.organization_id = organizationId)
  );
  if (organizationPerson) {
    roleId = organizationPerson.role_id;
  }
  return roleId;
};

export const getOrganization = (organizationsPersons) => {
  if (
    Object.prototype.toString.call(organizationsPersons) !== "[object Array]"
  ) {
    return null;
  }

  if (!organizationsPersons || !organizationsPersons.length) {
    return null;
  }
  const organizationPerson = organizationsPersons.find(
    (op) => (op.role_id = C.ACCOUNT_ADMIN_ROLE)
  );
  if (organizationPerson) {
    return organizationPerson.organization;
  }
  return null;
};

export const isClientAvailable = (user, userMeta) => {
  return (
    user.role_id === C.ADMIN_ROLE ||
    (user.person.organizations_persons &&
      userMeta &&
      userMeta.attributes &&
      userMeta.attributes.is_clients_available) ||
    false
  );
};

export const getInternalSplit = (
  userInvestorTargetInvestment,
  totalTargetInvestment
) => {
  return (
    Math.ceil((userInvestorTargetInvestment / totalTargetInvestment) * 10000) /
    100
  ).toFixed(2);
};

export const currencyRoundUp = (amount) => {
  return (Math.ceil(amount * 100).toFixed(2) / 100).toFixed(2);
};

export const getExactWireAmount = (numberOfShares, pricePerShare) => {
  return currencyRoundUp(pricePerShare * numberOfShares);
};

export const getPrimaryOrganizationPersonForUser = (user) => {
  return user.person.organizations_persons.sort((a, b) => a.id - b.id)[0]; //this will always return the user's oldest organization_person which should be their "primary" organization
};

export const getPrimaryOrganizationIdForUser = (user) => {
  return getPrimaryOrganizationPersonForUser(user).organization_id;
};

export const getPrimaryRoleIdForUser = (user) => {
  return getPrimaryOrganizationPersonForUser(user).role_id;
};
